import React from 'react';
import NlimsDataTable from '../../shared/NlimsDataTable/NlimsDataTable';
import { mortalityRecordsApi } from '../../../api/animalHealthApi';
import { useAnimalHealthRecords } from '../hooks/useAnimalHealthRecords';

const CONF_STYLE = {
  'Lab confirmed': 'background:#dcfce7;color:#15803d;border:1px solid #86efac;',
  'Field diagnosis': 'background:#eff6ff;color:#1d4ed8;border:1px solid #bfdbfe;',
  Suspected: 'background:#fef3c7;color:#b45309;border:1px solid #fcd34d;',
  Unknown: 'background:#f3f4f6;color:#6b7280;border:1px solid #e5e7eb;',
};

function confirmedHtml(data, type) {
  if (type !== 'display') return data ?? '';
  const s = CONF_STYLE[data] || 'background:#f3f4f6;color:#6b7280;';
  return `<span style="display:inline-flex;padding:2px 10px;border-radius:6px;font-size:11px;font-weight:600;${s}">${data || '-'}</span>`;
}

const THRESHOLD_STYLE = {
  Alert: 'background:#fee2e2;color:#dc2626;border:1px solid #fca5a5;',
  Normal: 'background:#f3f4f6;color:#6b7280;border:1px solid #e5e7eb;',
};

function thresholdHtml(data, type) {
  if (type !== 'display') return data ?? '';
  const s = THRESHOLD_STYLE[data] || 'background:#f3f4f6;color:#6b7280;';
  return `<span style="display:inline-flex;padding:2px 10px;border-radius:6px;font-size:11px;font-weight:600;${s}">${data || '-'}</span>`;
}

const COLUMNS = [
  { title: 'Livestock Species', data: 'species', sortable: true },
  { title: 'State', data: 'state', sortable: true },
  { title: 'Reference Period', data: 'refPeriod', sortable: true },
  { title: 'Mortality Count', data: 'mortalityCount', sortable: true },
  { title: 'Probable Cause', data: 'probableCause', sortable: true },
  { title: 'Disease Event', data: 'diseaseEvent', sortable: true },
  { title: 'LGA', data: 'lga', sortable: true },
  { title: 'Mortality Rate %', data: 'mortalityRate', sortable: true },
  { title: 'Population Base', data: 'populationBase', sortable: true },
  { title: 'Production System', data: 'productionSystem', sortable: true },
  { title: 'Age Class at Death', data: 'ageClassAtDeath', sortable: true },
  { title: 'Confirmed vs Suspected', data: 'confirmedVsSuspected', sortable: true, render: confirmedHtml },
  { title: 'Disposal Method', data: 'disposalMethod', sortable: true },
  { title: 'Mortality Threshold Alert', data: 'thresholdAlert', sortable: true, render: thresholdHtml },
];

export default function MortalityRecordsTab({ searchQuery = '' }) {
  const { filteredRecords, loading, error } = useAnimalHealthRecords(mortalityRecordsApi, searchQuery);

  return (
    <div className="space-y-3">
      {loading && (
        <div className="rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-700">
          Loading mortality records...
        </div>
      )}
      {error && (
        <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {error}
        </div>
      )}
      <NlimsDataTable
        tableId="mortality-records-table"
        columns={COLUMNS}
        data={filteredRecords}
        serverSide={false}
        hideSearch
        pageLength={10}
        enableRowSelection
      />
    </div>
  );
}
